import { render, staticRenderFns } from "./stocksBrokerfutures.vue?vue&type=template&id=1159d6e6&scoped=true&"
import script from "./stocksBrokerfutures.vue?vue&type=script&lang=ts&"
export * from "./stocksBrokerfutures.vue?vue&type=script&lang=ts&"
import style0 from "./stocksBrokerfutures.vue?vue&type=style&index=0&id=1159d6e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159d6e6",
  null
  
)

export default component.exports